import { motion, useSpring, useTransform, useReducedMotion, type MotionValue } from "framer-motion";

/**
 * Vertical "connective tissue" rail fixed to the left edge — a smoothed
 * fill + traveling dot tied to whole-page scroll progress, tying every
 * section together into one continuous journey.
 */
const ScrollProgressRail: React.FC<{ progress: MotionValue<number> }> = ({ progress }) => {
  const prefersReducedMotion = useReducedMotion();
  const smoothProgress = useSpring(progress, { stiffness: 90, damping: 24, mass: 0.4 });
  const dotTop = useTransform(smoothProgress, (v) => `${v * 100}%`);

  if (prefersReducedMotion) return null;

  return (
    <div className="fixed left-4 md:left-7 top-1/2 -translate-y-1/2 h-[42vh] md:h-[52vh] z-40 pointer-events-none hidden sm:block">
      <div className="relative h-full w-px bg-slate-900/10 dark:bg-white/10 rounded-full overflow-hidden">
        <motion.div
          className="absolute top-0 left-0 w-px bg-gradient-to-b from-[#172b81] to-[#e1ae48]"
          style={{ height: "100%", scaleY: smoothProgress, transformOrigin: "top" }}
        />
      </div>
      <motion.div
        className="absolute left-1/2 w-2 h-2 rounded-full -translate-x-1/2 -translate-y-1/2 bg-[#e1ae48] shadow-[0_0_8px_2px_rgba(225,174,72,0.5)]"
        style={{ top: dotTop }}
      />
    </div>
  );
};

export default ScrollProgressRail;
